/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type Accountabilities_organization$ref = any;
type WYSIWYGTextareaWithFeatureFlag_organization$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type LinkedRole_organization$ref: FragmentReference;
declare export opaque type LinkedRole_organization$fragmentType: LinkedRole_organization$ref;
export type LinkedRole_organization = {|
  +databaseId: string,
  +domainsLabel: string,
  +purposeLabel: string,
  +$fragmentRefs: Accountabilities_organization$ref & WYSIWYGTextareaWithFeatureFlag_organization$ref,
  +$refType: LinkedRole_organization$ref,
|};
export type LinkedRole_organization$data = LinkedRole_organization;
export type LinkedRole_organization$key = {
  +$data?: LinkedRole_organization$data,
  +$fragmentRefs: LinkedRole_organization$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LinkedRole_organization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    {
      "alias": "domainsLabel",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "domains"
        }
      ],
      "kind": "ScalarField",
      "name": "termFor",
      "storageKey": "termFor(name:\"domains\")"
    },
    {
      "alias": "purposeLabel",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "purpose"
        }
      ],
      "kind": "ScalarField",
      "name": "termFor",
      "storageKey": "termFor(name:\"purpose\")"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Accountabilities_organization"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WYSIWYGTextareaWithFeatureFlag_organization"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'e0275d7fb643328e7d4238022495c62a';

module.exports = node;
